/* ==========================================================================
   Kura Collection — Global JavaScript (vanilla, no dependencies)
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Scroll fade-in animation (subtle, respects reduced motion)
  ------------------------------------------------------------------ */
  function initFadeIn() {
    var els = document.querySelectorAll('.fade-in');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     Mobile menu
  ------------------------------------------------------------------ */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var close = document.querySelector('[data-menu-close]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    if (close) {
      close.addEventListener('click', function () {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  }

  /* ------------------------------------------------------------------
     Cart drawer
  ------------------------------------------------------------------ */
  var cartDrawer = {
    el: null,
    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && self.el.dataset.cartType === 'drawer') {
          e.preventDefault();
          self.open();
        }
        if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__overlay')) {
          self.close();
        }
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
          e.preventDefault();
          self.changeItem(removeBtn.dataset.cartRemove, 0);
        }
        var qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          e.preventDefault();
          var line = qtyBtn.dataset.line;
          var input = self.el.querySelector('[data-qty-input][data-line="' + line + '"]');
          var qty = parseInt(input.value, 10) + (qtyBtn.dataset.cartQty === 'plus' ? 1 : -1);
          if (qty < 0) qty = 0;
          self.changeItem(line, qty);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
    },
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    changeItem: function (line, quantity) {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { self.refresh(); })
        .catch(function (err) { console.error('Cart error', err); });
    },
    refresh: function () {
      var self = this;
      fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh && self.el) {
            self.el.innerHTML = fresh.innerHTML;
            if (self.el.classList.contains('is-open')) {
              self.el.classList.add('is-open');
            }
          }
          self.updateCount();
        });
    },
    updateCount: function () {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('hidden', cart.item_count === 0);
          });
        });
    }
  };

  /* ------------------------------------------------------------------
     Product form: AJAX add to cart
  ------------------------------------------------------------------ */
  function initProductForms() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var drawerEnabled = document.querySelector('[data-cart-drawer]') &&
          document.querySelector('[data-cart-drawer]').dataset.cartType === 'drawer';
        if (!drawerEnabled) return; // let it submit normally to /cart

        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var origText = btn.textContent;
        btn.disabled = true;
        btn.textContent = btn.dataset.addingText || 'Adding…';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Add to cart failed');
            return r.json();
          })
          .then(function () {
            cartDrawer.refresh();
            setTimeout(function () { cartDrawer.open(); }, 250);
          })
          .catch(function () {
            form.submit(); // graceful fallback
          })
          .finally(function () {
            btn.disabled = false;
            btn.textContent = origText;
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     Variant selection: update price, image & availability
  ------------------------------------------------------------------ */
  function initVariantPickers() {
    document.querySelectorAll('[data-product-wrapper]').forEach(function (wrapper) {
      var jsonEl = wrapper.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var form = wrapper.querySelector('form[data-product-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = wrapper.querySelector('[data-product-price]');
      var compareEl = wrapper.querySelector('[data-product-compare]');
      var btn = form ? form.querySelector('[type="submit"]') : null;

      function currentOptions() {
        var opts = [];
        wrapper.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          if (checked) opts[parseInt(fieldset.dataset.optionIndex, 10)] = checked.value;
        });
        return opts;
      }

      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function money(cents) {
        var fmt = wrapper.dataset.moneyFormat || '${{amount}}';
        var amount = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
      }

      wrapper.querySelectorAll('[data-option-index] input').forEach(function (input) {
        input.addEventListener('change', function () {
          var variant = findVariant(currentOptions());
          if (!variant) {
            if (btn) { btn.disabled = true; btn.textContent = btn.dataset.unavailableText || 'Unavailable'; }
            return;
          }
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = money(variant.price);
          if (compareEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compareEl.textContent = money(variant.compare_at_price);
              compareEl.classList.remove('hidden');
            } else {
              compareEl.classList.add('hidden');
            }
          }
          if (btn) {
            if (variant.available) {
              btn.disabled = false;
              btn.textContent = btn.dataset.addText || 'Add to cart';
            } else {
              btn.disabled = true;
              btn.textContent = btn.dataset.soldoutText || 'Sold out';
            }
          }
          if (variant.featured_image) {
            var mainImg = wrapper.querySelector('[data-gallery-main] img');
            if (mainImg) {
              mainImg.src = variant.featured_image.src;
              mainImg.srcset = '';
            }
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Product gallery thumbnails
  ------------------------------------------------------------------ */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main] img');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
          var img = thumb.querySelector('img');
          if (main && img) {
            main.src = img.dataset.full || img.src;
            main.srcset = '';
            main.alt = img.alt;
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Quantity steppers (product page + cart page)
  ------------------------------------------------------------------ */
  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.quantity');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      if (input.hasAttribute('data-qty-input')) return; // cart drawer handles itself
      var val = parseInt(input.value, 10) || 1;
      val += btn.dataset.qtyChange === 'plus' ? 1 : -1;
      if (val < 1) val = 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------------
     Collection sorting
  ------------------------------------------------------------------ */
  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-sort-by]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    initFadeIn();
    initMobileMenu();
    cartDrawer.init();
    initProductForms();
    initVariantPickers();
    initGalleries();
    initQuantitySteppers();
    initCollectionSort();
  });
})();
